import 'css-chunksrc/client/scenes/assignToTask/projectSelection/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_11urc_1"
};